import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import CustomMessageArea from '../../../components/customMessageArea';
import DotsLoading from '../../../components/dotsLoading';
import HeaderBasketButton from '../../../components/headerBasketButton';
import ShareTitleHeader from '../../../components/mazraeKit/headers/shareTitleHeader';
import Location from '../../../components/mazraeKit/location';
import RateStarBadge from '../../../components/RateStarBadge';
import CustomersPoint from '../../../module/newShop/detailShop/customersPoint';

import DetailShop from '../../../module/newShop/detailShop/detailShopText';
import useGetAdLikeStatus from '../../../services/hookService/getAdLikeStatus/useGetAdLikeStatus';
import useGetCommentsList from '../../../services/hookService/getComments/useGetCommentsList';
import useGetStoreInputGroups from '../../../services/hookService/getStoreInputGroups/useGetAdLikeStatus';
import usePatchPostLike from '../../../services/hookService/patchPostLike/usePatchPostLike';
import {advertisementType} from '../CategoryCardDetail';
import useGetDetailShopCard from './../../../services/hookService/getDetailShopCard/useGetDetailShopCard';
import AddCommentsBottomSheet from './addCommentsBottomSheet';
import BrandsSection from './BrandsSection';
import StoreDetailHeader from './StoreDetailHeader';
import Telephone from '../../../components/mazraeKit/Telephone';

const ShopDetails = () => {
  const navigate = useNavigate();
  const [openAddPoints, setOpenAddPoints] = useState<boolean>(false);
  const {guid} = useParams();

  const {cardDetailData, isLoading} = useGetDetailShopCard({guid: guid!});

  const {commentsList, commentsListIsLoading, refetchAllComments} =
    useGetCommentsList(guid);

  const {adLikeStatusData, refetch} = useGetAdLikeStatus(
    guid || '',
    !!guid,
    'stores',
  );
  const {editLikePost} = usePatchPostLike({
    onSuccessAction: () => {
      refetch();
    },
  });

  const {data: storInputs, isLoading: isStoreInputsLoading} =
    useGetStoreInputGroups({storeGuid: guid});

  const isPageLoading =
    isLoading || commentsListIsLoading || isStoreInputsLoading;

  // true quantity >= the request quantity which is min_sell_quantity
  const canAddOrder = () =>
    Math.abs(
      (cardDetailData?.basket_quantity ?? 0) -
        (cardDetailData?.hold_quantity ?? 0),
    ) >= (cardDetailData?.min_sell_quantity ?? 0);

  return (
    <div className="flex flex-col h-screen">
      <ShareTitleHeader
        title={cardDetailData?.title || ''}
        isLiked={adLikeStatusData?.like_status || false}
        onClickLike={() =>
          cardDetailData?.guid &&
          editLikePost({id: cardDetailData.guid, liking_type: 'stores'})
        }
        isSaleAgent={cardDetailData?.is_sale_agent ?? false}
        rightExtra={<HeaderBasketButton />}
      />
      {isPageLoading ? (
        <div className="flex justify-center items-center w-full h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          <div className="flex overflow-y-auto flex-col flex-1">
            <StoreDetailHeader
              logo={cardDetailData?.logo || ''}
              cover={cardDetailData?.store_photo}
            />
            <div className="flex justify-between items-center px-3 mt-4 w-full text-lg text-gray-900">
              <span className="font-bold text-md">
                {cardDetailData?.title || ''}{' '}
              </span>
              <RateStarBadge
                rate={cardDetailData?.rate ?? 0}
                propsClass="bg-transparent"
              />
            </div>
            <div className="px-3 mt-3">
              <Location
                state={cardDetailData?.state.name}
                city={cardDetailData?.city.name}
                address={cardDetailData?.address}
              />
            </div>
            {cardDetailData?.land_line && (
              <div className="px-3 mt-3">
                <Telephone landLine={cardDetailData?.land_line} />
              </div>
            )}
            <p className="p-0 m-0 px-4 w-full text-gray-900 text-md leading-[28px] mt-4 mb-3">
              {cardDetailData?.about}
            </p>
            <DetailShop {...cardDetailData} />
            {Boolean(storInputs?.length) && (
              <div className="flex flex-wrap gap-2 px-4 pt-4 pb-3 text-sm text-gray-700 border-b">
                {storInputs?.map(input => (
                  <span
                    key={input.guid}
                    className="content-center px-2 h-6 whitespace-nowrap bg-gray-100 rounded-full w-fit"
                  >
                    {input.title}
                  </span>
                ))}
              </div>
            )}
            {Boolean(cardDetailData?.store_brands.length) && (
              <BrandsSection cardDetailData={cardDetailData!} />
            )}

            <div
              className={`flex items-center justify-between px-4 py-3 mt-2 mb-4 ${
                Boolean(storInputs?.length)
                  ? 'text-red-600'
                  : 'text-gray-600 opacity-20 border-gray-500'
              }  border-y `}
              onClick={() => {
                if (Boolean(storInputs?.length))
                  navigate(`/store-select-input-advertisement/${guid}`);
              }}
            >
              <span className="font-semibold text-md">
                آگهی های این فروشگاه
              </span>
              <span className="text-2xl icon-nameArrow---Left-2"></span>
            </div>

            <div className="px-4 mt-11 mb-4">
              <CustomersPoint
                {...{
                  setOpenAddPoints,
                  guid,
                  commentsList,
                  commentsListIsLoading,
                }}
              />
            </div>

            <div className="py-3 mt-auto w-full border-t">
              <div
                className="flex gap-2 px-4"
                onClick={() => navigate(`/violation-report-store/${guid}`)}
              >
                <i className="text-[1.5rem] icon-namereport-2 text-red-1000" />
                <span className="flex justify-center items-center text-center text-red-1000 text-md">
                  گزارش تخلف
                </span>
              </div>
              <div className="mt-3 w-full text-gray-100 border-t"></div>
              <div
                className="flex gap-2 px-4 my-4"
                onClick={() => navigate('/rules')}
              >
                <i className="text-[1.5rem] icon-namelaw text-farm-shop-500" />
                <span className="flex justify-center items-center text-center">
                  قوانین و شرایط استفاده از فروشگاه
                </span>
              </div>
            </div>
          </div>
          <div className="flex w-full px-[12px] pt-[12px] pb-[24px] shadow-dropShadow rounded-top-left-1 rounded-top-right-1 border-top">
            {(advertisementType(cardDetailData) === 'lendTech-shop' ||
              advertisementType(cardDetailData) === 'brand-shop') &&
            storInputs ? (
              <div className="flex mt-auto w-full h-12 bg-white">
                <button
                  type="button"
                  className="w-full text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:text-gray-700"
                  onClick={() =>
                    navigate(`/store-select-input-advertisement/${guid}`)
                  }
                  disabled={!canAddOrder}
                >
                  سفارش محصول
                </button>
              </div>
            ) : (
              <CustomMessageArea
                phoneNumber={cardDetailData?.hide_phone_number}
                productId={guid}
                isShop={true}
                shopNumber={cardDetailData?.phone_number}
                supplierGuid={cardDetailData?.supplier_guid}
              />
            )}
          </div>
          <AddCommentsBottomSheet
            title={cardDetailData?.title || ''}
            {...{setOpenAddPoints, openAddPoints, guid, refetchAllComments}}
          />
        </>
      )}
    </div>
  );
};

export default ShopDetails;
